// extracted by mini-css-extract-plugin
export var alertIcon = "_ph-0";